export const getBackgroundImages = async (
  page: number = 1,
  limit: number = 10
) => {
  const response = await fetch(
    `/api/v1/background-images?page=${page}&limit=${limit}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || "Failed to get background images");
  }
  return response.json();
};

export const getRandomBackgroundImage = async () => {
  const response = await fetch("/api/v1/background-images/random", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(
      errorData.message || "Failed to get random background image"
    );
  }
  return response.json();
};
